(function () {
  'use strict';

  const selectors = {
    tracking: '[data-tracking-consent]',
    trackingAccept: '[data-confirm-cookies]',
    close: '[data-close-modal]',
    popupInner: '[data-popup-inner]',
    newsletterPopup: '[data-newsletter]',
    newsletterPopupHolder: '[data-newsletter-holder]',
    newsletterField: '[data-newsletter-field]',
    newsletterForm: '[data-newsletter-form]',
    promoPopup: '[data-promo-text]',
    delayAttribute: 'data-popup-delay',
    cookieNameAttribute: 'data-cookie-name',
    dataTargetReferrer: 'data-target-referrer',
  };

  const classes = {
    hasValue: 'has-value',
    success: 'has-success',
    desktop: 'desktop',
    mobile: 'mobile',
  };

  function fadeIn(el, display) {
    el.style.opacity = 0;
    el.style.display = display || 'block';
    (function fade() {
      var val = parseFloat(el.style.opacity);
      if (!((val += 0.1) > 1)) {
        el.style.opacity = val;
        requestAnimationFrame(fade);
      }
    })();
  }

  function fadeOut(el) {
    el.style.opacity = 1;
    (function fade() {
      if ((el.style.opacity -= 0.1) < 0) {
        el.style.display = 'none';
      } else {
        requestAnimationFrame(fade);
      }
    })();
  }

  class PopupCookie {
    constructor(name, value) {
      this.configuration = {
        expires: null,
        path: '/',
        domain: window.location.hostname,
      };
      this.name = name;
      this.value = value;
    }

    write() {
      const hasCookie =
        document.cookie.indexOf('; ') !== -1 &&
        !document.cookie.split('; ').find((row) => row.startsWith(this.name));
      if (hasCookie || document.cookie.indexOf('; ') === -1) {
        document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
      }
    }

    read() {
      if (
        document.cookie.indexOf('; ') !== -1 &&
        document.cookie.split('; ').find((row) => row.startsWith(this.name))
      ) {
        return document.cookie
          .split('; ')
          .find((row) => row.startsWith(this.name))
          .split('=')[1];
      }
      return false;
    }

    destroy() {
      if (document.cookie.split('; ').find((row) => row.startsWith(this.name))) {
        document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
      }
    }
  }

  class DelayShow {
    constructor(holder, element) {
      this.element = element;
      this.delay = holder.getAttribute(selectors.delayAttribute);

      if (this.delay === 'always') this.always();
      else if (this.delay === 'delayed') this.delayed();
      else if (this.delay === 'bottom') this.bottom();
      else if (this.delay === 'idle') this.idle();
    }

    always() {
      fadeIn(this.element);
    }

    delayed() {
      setTimeout(() => fadeIn(this.element), 10000);
    }

    bottom() {
      let raf;
      const onScroll = () => {
        if (raf) window.cancelAnimationFrame(raf);
        raf = window.requestAnimationFrame(() => {
          if (Math.round(window.scrollY + window.innerHeight) >= Math.round(document.body.clientHeight)) {
            fadeIn(this.element);
            window.removeEventListener('scroll', onScroll, { passive: true });
          }
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    idle() {
      let timer = 0;
      const idleTime = 60000;
      const documentEvents = ['mousemove', 'mousedown', 'click', 'touchmove', 'touchstart', 'touchend', 'keydown', 'keypress'];
      const windowEvents = ['load', 'resize', 'scroll'];

      const startTimer = () => {
        timer = setTimeout(() => {
          timer = 0;
          fadeIn(this.element);
        }, idleTime);
        documentEvents.forEach((e) => document.addEventListener(e, resetTimer));
        windowEvents.forEach((e) => window.addEventListener(e, resetTimer));
      };

      const resetTimer = () => {
        if (timer) clearTimeout(timer);
        documentEvents.forEach((e) => document.removeEventListener(e, resetTimer));
        windowEvents.forEach((e) => window.removeEventListener(e, resetTimer));
        startTimer();
      };

      startTimer();
    }
  }

  class TargetReferrer {
    constructor(el) {
      this.el = el;
      if (!this.el.hasAttribute(selectors.dataTargetReferrer)) return;
      if (
        location.href.indexOf(this.el.getAttribute(selectors.dataTargetReferrer)) === -1 &&
        !(window.Shopify && window.Shopify.designMode)
      ) {
        this.el.parentNode.removeChild(this.el);
      }
    }
  }

  class NewsletterPopup {
    constructor(el) {
      this.popup = el;
      this.popupInner = this.popup.querySelector(selectors.popupInner);
      this.holder = this.popup.querySelector(selectors.newsletterPopupHolder);
      this.close = this.popup.querySelector(selectors.close);
      this.newsletterField = this.popup.querySelector(selectors.newsletterField);
      this.cookie = new PopupCookie(this.popup.getAttribute(selectors.cookieNameAttribute), 'newsletter_is_closed');
      this.form = this.popup.querySelector(selectors.newsletterForm);
      new TargetReferrer(this.popup);
      this.init();
    }

    init() {
      const cookieExists = this.cookie.read() !== false;
      if (!cookieExists || (window.Shopify && window.Shopify.designMode)) {
        this.show();
        if (this.form && this.form.classList.contains(classes.success)) {
          this.checkForSuccess();
        }
      }
    }

    show() {
      if (!(window.Shopify && window.Shopify.designMode)) {
        new DelayShow(this.popup, this.popupInner);
      } else {
        fadeIn(this.popupInner);
      }
      this.inputField();
      this.closePopup();
    }

    checkForSuccess() {
      fadeIn(this.popupInner);
      this.cookie.write();
    }

    closePopup() {
      if (!this.close) return;
      this.close.addEventListener('click', (event) => {
        event.preventDefault();
        fadeOut(this.popupInner);
        this.cookie.write();
      });
    }

    inputField() {
      if (!this.newsletterField) return;
      this.newsletterField.addEventListener('input', () => {
        if (this.newsletterField.value !== '') {
          this.holder.classList.add(classes.hasValue);
        }
      });
      this.newsletterField.addEventListener('focus', () => {
        if (this.newsletterField.value !== '') {
          this.holder.classList.add(classes.hasValue);
        }
      });
      this.newsletterField.addEventListener('focusout', () => {
        setTimeout(() => this.holder.classList.remove(classes.hasValue), 2000);
      });
    }
  }

  class PromoText {
    constructor(el) {
      this.popup = el;
      this.popupInner = this.popup.querySelector(selectors.popupInner);
      this.close = this.popup.querySelector(selectors.close);
      this.cookie = new PopupCookie(this.popup.getAttribute(selectors.cookieNameAttribute), 'user_has_closed');
      new TargetReferrer(this.popup);
      this.init();
    }

    init() {
      const cookieExists = this.cookie.read() !== false;
      if (!cookieExists || (window.Shopify && window.Shopify.designMode)) {
        if (!(window.Shopify && window.Shopify.designMode)) {
          new DelayShow(this.popup, this.popupInner);
        } else {
          fadeIn(this.popupInner);
        }
        this.clickEvents();
      }
    }

    clickEvents() {
      if (!this.close) return;
      this.close.addEventListener('click', (event) => {
        event.preventDefault();
        fadeOut(this.popupInner);
        this.cookie.write();
      });
    }
  }

  function initPopups(container) {
    container.querySelectorAll(selectors.newsletterPopup).forEach((el) => new NewsletterPopup(el));
    container.querySelectorAll(selectors.promoPopup).forEach((el) => new PromoText(el));
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-section-type="popups"]').forEach((section) => {
      initPopups(section);
    });
  });

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (section.querySelector('[data-section-type="popups"]')) {
      initPopups(section.querySelector('[data-section-type="popups"]'));
    }
  });
})();
